import { createSlice } from '@reduxjs/toolkit';
import enabledViewStorage from 'src/react/recommendations/store/enabledViewStorage';
import { EXPLORE_ROUTE, MY_LIST_ROUTE } from 'src/react/recommendations/Layout';
import logger from 'src/analytics/logger';

const initialState = {
  current: MY_LIST_ROUTE
};

const pageViewName = {
  [MY_LIST_ROUTE]: 'My List',
  [EXPLORE_ROUTE]: 'Explore'
};

const logPageView = (currentView) => {
  logger.logPageView('Recommendations', pageViewName[currentView], {});
};

export const viewSlice = createSlice({
  name: 'view',
  initialState: initialState,
  reducers: {
    setInitialView(state, action) {
      const payload = action?.payload;
      const currentView = enabledViewStorage.get() || payload;

      if (state.current === currentView) {
        return;
      }

      logPageView(currentView);
      state.current = currentView;
    },
    setCurrentView(state, action) {
      const payload = action?.payload;
      if (!payload || state.current === payload) {
        return;
      }

      enabledViewStorage.set(payload);
      logPageView(payload);
      state.current = payload;
    }
  }
});

// Action creators are generated for each case reducer function
export const { setInitialView, setCurrentView } = viewSlice.actions;

export const selectCurrentView = (state) => state.view.current;

export default viewSlice.reducer;
